import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const GoogleMapsListWidget: WidgetRegistryEntry = {
  name: "GoogleMapsList",
  configuration: () => import("./configuration").then((m) => m.GoogleMapsListWidgetConfiguration),
  component: () => import("./google-maps-list-widget.component").then((m) => m.GoogleMapsListWidgetComponent)
};
